import { render, staticRenderFns } from "./TagsAttrs.vue?vue&type=template&id=2a49142f"
import script from "./TagsAttrs.vue?vue&type=script&lang=js"
export * from "./TagsAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports